import axiosHttp from "./interceptor.service";
const getUserReport = ({
  page,
  limit,
  sort,
  search,
  issueType,
  startDate,
  endDate,
  payable
} = {}) => {
  return axiosHttp.get(`/lmt/candidateHistory`, {
    params: { sort, limit, page, search, issueType, startDate, endDate, payable },
  });
};
export { getUserReport };
